import { BaseRootStore } from '../../../rootStore/baseRootStore';
import type UserStore from '../../UserStore';

/**
 * Calculates the total number of unique user seats across all organizations
 * owned by the specified user. The owner themselves is NOT counted as a seat.
 */
export const calculateTotalUsedSeats = (
  organizations: UserStore<BaseRootStore>['userDataOrganizations']['orgs'],
  ownerUuid: string,
): number => {
  const uniqueUsers = new Set<string>();

  organizations?.forEach((org) => {
    if (org?.ownerUuid !== ownerUuid) {
      return;
    }

    (org?.users ?? []).forEach((user) => {
      if (!user?.userUuid) {
        return;
      }

      // Exclude the owner from the seat count
      if (user.userUuid === ownerUuid) {
        return;
      }

      uniqueUsers.add(user.userUuid);
    });
  });

  return uniqueUsers.size;
};
